import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";
import userInfoStore from "@/store/user.store";
import { useMemo } from "react";

const usePermission = () => {
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  const userId = userInfoStore((state) => state.userId);

  // 兼容旧创建的会议
  const isOwner = detailInfo?.userId === userId || detailInfo?.isOwner;
  const allowBackUp = detailInfo?.allowBackUp;

  // 当为仅查看并且不能创建副本时不展示重新编辑/重新总结icon
  const showEdit = useMemo(() => {
    if (!isOwner && !allowBackUp) {
      return false;
    } else if (!shareInfo) {
      return true;
    } else if (isOwner) {
      return true;
    }
  }, [allowBackUp, isOwner, shareInfo]);

  return {
    isOwner,
    allowBackUp,
    showEdit,
  };
};

export default usePermission;
